/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const headerBusinessModelDtoSchema = z.object({
  model: z.optional(z.string()),
  description: z.optional(z.string()),
  modelType: z.optional(z.string()),
});
